<template>
  <modal name="modal-age-confirm" :width="720">
    <div class="modal-content">
      <div class="py50 center-md center-xs">
        <img
          src="/assets/image-alcohol.png"
          alt="Alcohol"
          width="133"
          height="127"
          loading="eager"
          fetchpriority="high"
        >
        <p class="top-text">{{$t('Are you already 18?')}}</p>
        <div class="flex button-block">
          <div @click="confirm(false)" class="button-no">{{$t('No')}}</div>
          <div @click="confirm(true)" class="button-yes">{{$t('Yes')}}</div>
        </div>
        <p class="bottom-text">{{$t('We do not sell prohibited goods to minors')}}</p>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex'
import Modal from 'theme/components/core/Modal'
import { AgeConfirmation } from '@vue-storefront/core/modules/user/components/AgeConfirmation';

export default {
  name: 'AgeConfirmation',
  mixins: [ AgeConfirmation ],
  computed: {

  },
  components: {
    Modal
  },
  methods: {
    close () {
      this.notifyUser({
        type: 'error',
        message: this.$t('To buy this product your age should be 18 or higher!'),
        action1: { label: this.$t('OK') },
        action2: null
      })
      this.$bus.$emit('modal-hide', 'modal-age-confirm')
    }
  }
}
</script>

<style scoped>
.button-yes {
  width: 40%;
  background: #11bb2e;
  padding: 10px;
  margin-left: 30px;
  border-radius: 10px;
  cursor: pointer;
  color: #ffffff;
}
.button-block {
  width: 50%;
  margin: 0 auto;
}
.button-no {
  width: 40%;
  background: #e02124;
  padding: 10px;
  border-radius: 10px;
  cursor:pointer;
  color:#ffffff;
}
.bottom-text {
  font-family: 'TTNorms Medium';
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.05px;
  text-align: center;
  color: #000000;
}
.top-text {
  font-family: 'TTNorms Medium';
  font-size: 16px;
  font-weight: 800;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.1px;
  text-align: center;
  color: #000000;
}
</style>
